
$(document).ready(function() {
  if (window.location.href.indexOf("filter") === -1) {
    if( $('#shopify-section-template--16788038746159__collection-nav').length ) {
      $('#shopify-section-template--16788038746159__collection-nav').addClass('is-visible');    
    }
  }
});

// Pandectes CMP is rendered inside Shadow DOM, so theme CSS can't style its buttons.
// Inject a small style override into the open shadowRoot to control hover visuals.
(function initPandectesCmpHoverOverride() {
  const STYLE_ID = 'theme-pandectes-cmp-hover-override';

  const css = `
    @media (hover: hover) {
      .dialog .actions button:hover,
      div.actions button:hover {
        opacity: 1 !important;
        background-color: #000 !important;
        color: #fff !important;
        border-color: #000 !important;
        box-shadow: none !important;
      }
    }
  `;

  function tryInject() {
    const host = document.querySelector('pandectes-cmp[data-active-instance="true"], pandectes-cmp');
    if (!host || !host.shadowRoot) return false;

    if (host.shadowRoot.getElementById(STYLE_ID)) return true;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    host.shadowRoot.appendChild(style);
    return true;
  }

  if (tryInject()) return;

  const observer = new MutationObserver(() => {
    if (tryInject()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', () => {
    tryInject();
    observer.disconnect();
  });
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}


customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('.mobile-facets__close').forEach(button => button.addEventListener('click', this.onSummaryClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else if (event.currentTarget.classList.contains('mobile-facets__close')) {
      this.closeMenuDrawer(event);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('mobile-menu-open', `overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove('mobile-menu-open', `overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('mobile-menu-open', `overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    // this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (!this.currentPage) {
      this.currentPage = 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      // this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class SlideshowAboutComponent extends SliderComponent {
  constructor() {
    super();
  }

  update() {
    super.update();

    if (!this.footerTitle) {
      this.footerTitle = this.querySelector('.slideshow__footer .slide__title__link');
    }
    
    if (this.sliderItemsToShow[this.currentPage - 1]) {
      this.footerTitle.href = this.sliderItemsToShow[this.currentPage - 1].dataset.href;
      this.footerTitle.title = this.sliderItemsToShow[this.currentPage - 1].dataset.title;
      this.footerTitle.innerHTML = this.sliderItemsToShow[this.currentPage - 1].dataset.title;
    }
  }
}

customElements.define('slideshow-about-component', SlideshowAboutComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      // this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      // this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;

  //   if (this.currentVariant && this.currentVariant.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //     pickUpAvailability.setAttribute('available', '');
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });

      // if(!this.currentVariant.available){

      //     console.log("show the out of stock message");
      //     $('.pickup-availability__unavailable_message').addClass('is-visible');
      // } else {
      //     console.log("hide  out of stock message");
      //     $('.pickup-availability__unavailable_message').removeClass('is-visible');
      // }


  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    addButton.classList.remove('size-selectable')

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);






// For complementary Products
// class ProductRecommendations extends HTMLElement {
//   observer = undefined;

//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.initializeRecommendations(this.dataset.productId);
//   }

//   initializeRecommendations(productId) {
//     this.observer?.unobserve(this);
//     this.observer = new IntersectionObserver(
//       (entries, observer) => {
//         if (!entries[0].isIntersecting) return;
//         observer.unobserve(this);
//         this.loadRecommendations(productId);
//       },
//       { rootMargin: '0px 0px 400px 0px' }
//     );
//     this.observer.observe(this);
//   }

//   loadRecommendations(productId) {
//     fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
//       .then((response) => response.text())
//       .then((text) => {
//         const html = document.createElement('div');
//         html.innerHTML = text;
//         const recommendations = html.querySelector('complementary-products');

//         if (recommendations?.innerHTML.trim().length) {
//           this.innerHTML = recommendations.innerHTML;
//         }

//         if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
//           this.remove();
//         }

//         if (html.querySelector('.grid__item')) {
//           this.classList.add('product-recommendations--loaded');
//         }
//       })
//       .catch((e) => {
//         console.error(e);
//       });
//   }
// }

// customElements.define('complementary-products', ProductRecommendations);





class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}
















class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


/* Custom code */
document.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', '.card-variant', function() {
    if ($(this).hasClass('selected')) {
      $(this).removeClass('selected');
      $(this).closest('.card').removeClass('card--variant-selected');
      return;
    }
    
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');

    $(this).closest('.card').addClass('card--variant-selected');
  });

  $(document).on('click', '.card__toolbar--label', function() {
    const $card = $(this).closest('.card');
    if ($card.hasClass('card--variant-selected')) {
      const $variant = $card.find('.card-variant.selected');
      if ($variant.length == 0) {
        return false;
      }

      const variantId = $variant.data('variantId');
      $.post('/cart/add.js', {
        id: variantId,
        quantity: 1,
        sections: [
          'cart-drawer',
          'cart-icon-bubble'
        ],
        sections_url: window.location.pathname
      }, function(response) {
        if (response.status) {
          return;
        }
        
        const cart = document.querySelector('cart-drawer');
        cart.renderContents(response);
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }

        $('#cart-icon-bubble').trigger('click');
      }, 'json');
    }
  });

  /* Collection / Subtype filter */
  function syncSubtypeFilterState() {
    const $form = $('facet-filters-form').first();
    if (!$form.length) return;

    $('.template-collection .subtype-trigger').each(function() {
      const $trigger = $(this);
      const name = $trigger.data('name');
      const value = $trigger.data('value');
      const $checkbox = $form.find(`input[type="checkbox"][name="${name}"][value="${value}"]`);
      $trigger.closest('li').toggleClass('active', !!$checkbox.length && $checkbox.prop('checked'));
    });
  }

  $(document).on('click', '.template-collection .subtype-trigger', function(e) {
    e.preventDefault();

    const $trigger = $(this);
    const name = $trigger.data('name');
    const value = $trigger.data('value');
    const $form = $('facet-filters-form').first();
    const $checkbox = $form.find(`input[type="checkbox"][name="${name}"][value="${value}"]`);

    if (!$checkbox.length) return;

    const checkboxEl = $checkbox.get(0);
    const nextCheckedState = !checkboxEl.checked;
    checkboxEl.click();
    $trigger.closest('li').toggleClass('active', nextCheckedState);

    return;
  });

  syncSubtypeFilterState();

  /* Product Gallery pagination */
  let stop_scroll_event = false;
  const $gallery = $('slider-component');
  const $gallery_media_list = $gallery.find('.product__media-list');
  const $gallery_pagination = $('.product-gallery-pagination');
  const count = $gallery.find('.product__media-item').length;

  /* check which product gallery image is currently visible */
  function checkGalleryPaginationDesktop() {
    var scrollTop = $gallery.scrollTop();
    $gallery_pagination.find('span.active').removeClass('active');

    for (var i = count - 1; i >= 0; i--) {
      var $productImage = $gallery.find('.product__media-item').eq(i);

      const imageTop = $productImage.offset().top;
      const listTop = $gallery_media_list.offset().top;
      const y = imageTop - listTop;

      if (y - 300 <= scrollTop) {
        $gallery_pagination.children('span').eq(i).addClass('active');
        return false;
      }
    }
  }

  $gallery_pagination.on('click', 'span', function(e) {
    e.preventDefault();

    var $paginationItem = $(this);
    if ($paginationItem.hasClass('active')) {
      return;
    }

    var index = $gallery_pagination.find('span').index($paginationItem),
        $productImage = $('.product__media-list .product__media-item').eq(index);

    $(this).addClass('active').siblings().removeClass('active');
    
    const y = $productImage.offset().top - $gallery_media_list.offset().top;
    if (window.innerWidth >= 750) {
      // Desktop
      stop_scroll_event = true;

      $gallery.animate({
        scrollTop: y,
      }, {
        duration: 400,
        done: function() {
          stop_scroll_event = false;
        }
      });
    } else {
      // Mobile
      const y = $productImage.offset().top + $gallery_media_list.scrollTop();
      $gallery_media_list.scrollTop(y);
    }
  });

  var timerDesktop = false;
  $gallery.scroll(function() {
    if (stop_scroll_event) {
      return;
    }

    if (timerDesktop) {
      clearTimeout(timerDesktop);
    }

    timerDesktop = setTimeout(function() {
      checkGalleryPaginationDesktop();
    }, 100);
  });

  /* Mobile navigation */
  function checkGalleryPaginationMobile() {
    var scrollLeft = $gallery_media_list.scrollLeft();
    $gallery_pagination.find('span.active').removeClass('active');

    for (var i = count - 1; i >= 0; i--) {
      var $productImage = $gallery.find('.product__media-item').eq(i);

      const x = $productImage.offset().top;
      if (x <= 30) {
        $gallery_pagination.children('span').eq(i).addClass('active');
        return false;
      }
    }    
  }

  $gallery_media_list.scroll(function(e) {
    if (window.innerWidth >= 750) {
      return; 
    }

    if (stop_scroll_event) {
      return;
    }

    checkGalleryPaginationMobile();
  });

  /* Find My Size */
  var detailsSizeGuide = document.querySelector('.size-guide');
  if (detailsSizeGuide) {
    detailsSizeGuide.addEventListener('toggle', function() {
      if (this.open) {
        document.body.classList.add('overflow-hidden', 'size-guide-open');
      } else {
        document.body.classList.remove('overflow-hidden', 'size-guide-open');
      }
    });

    $('.btn-find-my-size').on('click', function() {
      $('.modal-size-guide').addClass('is-visible');
    });
      
    
    $('.product-media-modal__toggle').on('click', function() {
      $('.modal-size-guide').removeClass('is-visible');
    });


    $('.modal-size-guide').on('click', '.product-media-modal__toggle', function() {
      // Close modal

      $(this).closest('details').removeAttr('open');

    }).on('click', '.unit-toggle', function() {
      // Toggle IN <=> CM
      $(this).closest('.modal-size-guide').attr('data-unit', this.dataset.value);
    });
  }

  /* Mega menu */
  

  var megaMenus = document.querySelectorAll('header .mega-menu');

  megaMenus.forEach(megaMenu => {

    megaMenu.addEventListener("toggle", function() {
      
      const openMenu = document.querySelector('.mega-menu[open]');
      // if (openMenu) {            
      //   document.body.classList.add('mega-menu-open');
      // } else {        
      //   document.body.classList.remove('mega-menu-open');
      // }
    });

  //   // megaMenu.addEventListener('mouseenter', (e) => {      
  //   //   // close other mega menus first
  //   //   megaMenus.forEach(item => {
  //   //     item.removeAttribute('open');
  //   //   });
      
  //   //   megaMenu.setAttribute('open', '');

  //   // });

  //   // megaMenu.addEventListener('mouseleave', (e) => {
      
  //   //   if (e.toElement && e.toElement.tagName !== 'HEADER') {        
  //   //     megaMenu.removeAttribute('open');
  //   //   }
    // })
  });

  const menus = document.querySelectorAll('.header-level-0')
  
  document.addEventListener('click', function(){
    
    var toggle = false;
    menus.forEach(menu => {
      if (menu.getAttribute('aria-expanded') == 'true'){
        toggle = true;
      }
    })
    if (toggle){
      document.body.classList.add('mega-menu-open');
    } else{
      document.body.classList.remove('mega-menu-open');
    }
  });

  // $(function() {
  //   $('details.mega-menu').on('mouseenter', function() {
  //     $(this).attr('open', true);
  //   });

  //   $('.header__inline-menu').on('mouseout', function() {
  //     $(this).attr('open', false);
  //   })
  // });

  // document.addEventListener('mouseover', function(){
  //     console.log("hover");
  //   var toggle = false;
  //   menus.forEach(menu => {
  //     if (menu.getAttribute('aria-expanded') == 'true'){
  //       toggle = true;
  //     }
  //   })
  //   if (toggle){
  //     document.body.classList.add('mega-menu-open');
  //   } else{
  //     document.body.classList.remove('mega-menu-open');
  //   }
  // });

  $('.header__icons--mobile .header__icon--search').on('click', function() {
    
     $('body').removeClass('mobile-menu-open');
     $('body').removeClass('mega-menu-open');
     $('#shopify-section-header').removeClass('menu-open');
     $('#Details-menu-drawer-container').removeClass('menu-opening');
  });

});


  // shipping bar and notification bar
  // = wait till shipping bar, heigh adj

  // shipping bar
  // = just show, no height adj

  // notification bar
  // - just show, no waiting

  // no announcment bar
  // - nothoing







  waitForElementToDisplay(".ge-free-shipping-container",function(){
    waitForElementToDisplay("#shopify-section-announcement-bar",function(){
    
      var notification_bar = document.getElementById('shopify-section-announcement-bar');
      var shipping_bar = document.querySelector('.ge-free-shipping-container');      
      if (!!notification_bar && !!shipping_bar) {      
        notification_bar.style.transform = "translateY(-" + shipping_bar.clientHeight + "px)";
        notification_bar.style.visibility = "visible";
        notification_bar.style.maxHeight = "initial";
        shipping_bar.style.transform = "translateY(" + notification_bar.clientHeight + "px)";        
        shipping_bar.style.visibility = "visible";      
        shipping_bar.style.maxHeight = "initial";
      }

    },500,20000);

  },500,20000);


  function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
      if (document.querySelector(selector) != null) {
        callback();
        return;
      }
      else {
        setTimeout(function () {
          if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
            return;
          loopSearch();
        }, checkFrequencyInMs);
      }
    })();
  }


$('#Details-menu-drawer-menu-item-mobile-nav .menu-drawer__menu-item').on('click', function() {
  $('body').addClass("region-select-open");
});


$('#Details-menu-drawer-menu-item-mobile-nav .drawer__close').on('click', function() {
  $('body').removeClass("region-select-open");
});

document.addEventListener('Loop:Activated', () => {
  window.location.href='collections/new-releases';
});


 var BrowserDetect = {
        init: function () {
            this.browser = this.searchString(this.dataBrowser) || "Other";
            this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
        },
        searchString: function (data) {
            for (var i = 0; i < data.length; i++) {
                var dataString = data[i].string;
                this.versionSearchString = data[i].subString;

                if (dataString.indexOf(data[i].subString) !== -1) {
                    return data[i].identity;
                }
            }
        },
        searchVersion: function (dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index === -1) {
                return;
            }

            var rv = dataString.indexOf("rv:");
            if (this.versionSearchString === "Trident" && rv !== -1) {
                return parseFloat(dataString.substring(rv + 3));
            } else {
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            }
        },

        dataBrowser: [
            {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
            {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
            {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
            {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
            {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
            {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  

            {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
            {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
        ]
    };

    BrowserDetect.init();
    document.write("You are using <b>" + BrowserDetect.browser + "</b> with version <b>" + BrowserDetect.version + "</b>");

    var bv= BrowserDetect.browser;
    if( bv == "Chrome"){
        $("body").addClass("chrome");
    }
    else if(bv == "MS Edge"){
     $("body").addClass("edge");
    }
    else if(bv == "Explorer"){
     $("body").addClass("ie");
    }
    else if(bv == "Firefox"){
     $("body").addClass("Firefox");
    }
    else if(bv == "Safari"){
     $("body").addClass("Safari");
    }

function getCookie(user) {
    var cookieArr = document.cookie.split(";");
    for(var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");
        if(user == cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}



// Hold down the SHIFT + CONTROL + OPTION + P keys to view debug info
document.onkeyup = function(e) {
 if (e.ctrlKey && e.altKey && e.shiftKey && e.which == 80) {
  document.body.classList.toggle("show-debug-info");
 }
};

var btn = $('#backToTop');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});


/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
function getCookie (name) {
  // let value = `; ${document.cookie}`;
  // let parts = value.split(`; ${name}=`);
  // if (parts.length === 2) return parts.pop().split(';').shift();
}


// Add the Archive Sale Nav if they visited the page before.
const getCookieValue = (name) => (
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
)


let archive_status = getCookie('archive_sale_2023');

const saleMenus = document.getElementsByClassName('archive-sale__nav');

if (archive_status) {
  for (var i = 0; i < saleMenus.length; i++) {
      saleMenus[i].style.display="block";
  }
}




// const privateSaleCookie = getCookie('archive_sale');
// const saleMenus = document.getElementsByClassName('archive-sale__nav');

// if (privateSaleCookie == true) {
//   for (var i = 0; i < saleMenus.length; i++) {
//       console.log("Sss");
//       saleMenus[i].style.display="block";
//   }
// }








// var current_title = document.title;

// function timeout() {
//     setTimeout(function () {
//         if (document.title == current_title) {
//           document.title = "60% OFF Friend & Family Sale - PURPLE BRAND";
//         } else {
//           document.title = current_title;
//         }
//         timeout();
//     }, 3000);
// }
// timeout();




// var mobileMenu = document.querySelector('.header__bag--mobile');function distance(lon1, lat1, lon2, lat2) {
//   var R = 6371; // Radius of the earth in km
//   var dLat = (lat2-lat1).toRad();  // Javascript functions in radians
//   var dLon = (lon2-lon1).toRad(); 
//   var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
//           Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) * 
//           Math.sin(dLon/2) * Math.sin(dLon/2); 
//   var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
//   var d = R * c; // Distance in km
//   return d;
// }

// /** Converts numeric degrees to radians */
// if (typeof(Number.prototype.toRad) === "undefined") {
//   Number.prototype.toRad = function() {
//     return this * Math.PI / 180;
//   }
// }


// window.navigator.geolocation.getCurrentPosition(function(pos) {
//   // console.log(pos); 
//   // console.log(pos.coords.longitude); 
//   // console.log(pos.coords.latitude); 
//   // console.log(
//   //   distance(pos.coords.longitude, pos.coords.latitude, -122.8276742, 49.2752854 )
//   // );

//   var longOfDestination = -74.00188414418078;
//   var latOfDestination = 40.72035296858743;
//   var distanceTreshold = 150; //in km
//   var distanceBetween = distance(pos.coords.longitude, pos.coords.latitude, longOfDestination, latOfDestination);
  
//   if(distanceBetween < distanceTreshold){
//     document.getElementById('widget-_tote').classList.add('is-visible');
//   }
// });


waitForElm('.upcart-header-close-button').then((elm) => {
    
    var mobileMenuClose = document.querySelector('.upcart-header-close-button');
  
    mobileMenuClose.addEventListener("click", function() {
      console.log("cloing");
      document.querySelector('.upcart-cart').classList.remove('styles_active__7AzVD');
      document.body.classList.remove('overflow-hidden');
      document.querySelector('.drawer').classList.remove('animate');
      document.querySelector('.drawer').classList.remove('active');
  });
});

// Deactivating while Upcart App is still enabled
// mobileMenu.addEventListener("click", function() {
//     document.querySelector('.upcart-cart').classList.add('styles_active__7AzVD');
// });


function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}



if(document.body.classList.contains('fleece-set')) {

  let anchor = document.querySelector('#product-grid > li:nth-child(9)');
  let anchorLower = document.querySelector('#product-grid > li:nth-child(18)');
  let anchorDeepLower = document.querySelector('#product-grid > li:nth-child(22)');

  anchor.outerHTML += `<div style="width:100%;display: block;"></div>`;
  anchorLower.outerHTML += `<div style="width:100%;display: block;"></div>`;
  anchorDeepLower.outerHTML += `<div style="width:100%;display: block;"></div>`;
}


var url_string = window.location.href; 
var url = new URL(url_string);
var parm = url.searchParams.get("filter.p.product_type");
var pathname = url.pathname;

if (typeof parm !== 'undefined' && parm !== null && parm !== '') {
  parm.toLowerCase();
  document.body.classList.add('friends-and-family-' + parm);
}

if (typeof pathname !== 'undefined' && pathname !== null && pathname !== '' && pathname !== '/') {
  pathname = pathname.toLowerCase().replace(/\//g, "");
  document.body.classList.add(pathname);
}


$(document).ready(function() {
  $('.collection-nav--headline').addClass("is-sliding");
});


// Handle Tabs
const tabs = document.querySelectorAll(".toggle-tabs .toggle-tabs__tabs li");
const sections = document.querySelectorAll(".toggle-tabs .toggle-tabs__tab-content");

tabs.forEach(tab => {
  tab.addEventListener("click", e => {
    e.preventDefault();
    removeActiveTab();
    addActiveTab(tab);
  });
})

const removeActiveTab = () => {
  tabs.forEach(tab => {
    tab.classList.remove("is-active");
  });
  sections.forEach(section => {
    section.classList.remove("is-active");
  });
}

const addActiveTab = tab => {
  tab.classList.add("is-active");
  const href = tab.querySelector("a").getAttribute("href");
  const matchingSection = document.querySelector(href);
  matchingSection.classList.add("is-active");
}



// Handle Videos
// $( window ).on( "load", function() {  
//   document.querySelectorAll('.bg-video').forEach(item => {
//     if(item.currentTime > 0) {
//       $('.bg-video').addClass('is-visible');
//     }
//   });
// });

    $( window ).on( "load", function() {  
      document.querySelectorAll('video').forEach(item => {
        if(item.currentTime > 0) {
          $('.card__video-image-overlay').addClass('is-hidden'); 
          $('.bg-video').addClass('is-visible'); 
          
        }
      });
    });
// $( window ).on( "load", function() {  
//   console.log("loaded");

//   document.querySelectorAll('.bg-video').forEach(item => {
//     item.addEventListener("play", (event) => {
//       $('.bg-video__video-image-overlay').addClass('is-hidden');
//       $('.bg-video').addClass('is-visible');

//     });
//   });
// });

// $('body').on('click touchstart', function ()  {
//   var videoElement = document.getElementsByClassName('bg-video');
//   if (videoElement.playing) {
//     $('.bg-video__video-image-overlay').addClass('is-hidden');
//     $('.bg-video').addClass('is-visible');
//   } else {
//     $('.bg-video').trigger('play');
//     $('.bg-video__video-image-overlay').addClass('is-hidden');
//     $('.bg-video').addClass('is-visible');
//   }
// });


$('.product__sale-button').on('click', function() {
  $(this).addClass('is-hidden');
  $('.product__sale-signup').addClass('is-visible')
});


$('.lookbook__product-toggle').on('click', function() {
  console.log("bbbbbbb");
  $(this).closest('.lookbook__gallery-container').toggleClass('is-active');
});


// $('.sibling-shortcut').on('click', function(){
//   $('sibling-drawer').addClass('active');
//   $('body').addClass('overflow-hidden');
// });

// $('.sibling-drawer__close').on('click', function(){
//   $('sibling-drawer').removeClass('active');
//   $('body').removeClass('overflow-hidden');
// });

// $('.sibling-drawer.active').on('click', function(){
//   console.log("hapenend here");
//   $('sibling-drawer').removeClass('active');
//   $('body').removeClass('overflow-hidden');
// });

 
// window.onclick = function(event)
// {
//     console.log(event.target);
// }

// this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));


// window.addEventListener('click', function(e) {   
//   if ( $('sibling-drawer').hasClass('active') ) {
    
//     if (document.getElementById('sibling__inner').contains(e.target) )  {
//       console.log("s");
//     } else {
//       $('sibling-drawer').removeClass('active');
//       $('body').removeClass('overflow-hidden');
//     }
//   }
// });


// var divCheckingInterval = setInterval(function(){
//     // Find it with a selector
//     if(document.querySelector("#ps__widget_container")){
        
//         console.log("length", document.querySelector("#ps__widget_container").offsetWidth);


//         clearInterval(divCheckingInterval);
//         // Do something
//     }
// }, 500);







// waitForElm('.xse_compare_price').then((elm) => {

//   setTimeout(() => {
  
//     const compare_prices = document.getElementsByClassName("xse_compare_price");
//     const reg_prices = document.getElementsByClassName("xse_prod_price");

//     for (let i = 0; i < compare_prices.length; i++) {
//       // compare_prices.classList.add('xgen_fix_compare');
//       // compare_prices[i].innerText = compare_prices[i].innerText.replace("&#36;", "$");    
//     }

//     for (let i = 0; i < reg_prices.length; i++) {
//       // console.log("here:", collection[i].innerText);      
//       // reg_prices[i].innerText = reg_prices[i].innerText.replace("&#36;", "$");    
//     }

//   }, 1000);

// });


